import { render } from 'react-dom';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { RouteErrorBoundary } from '@components/route-error-boundary';
import { Toaster } from '@components/toaster';
import { setSentryContext, startSentry } from '@utils/sentry';

import { ComboSendForm } from 'components/combo-send-form';
import { JourneyForm } from 'components/journey-form';

import { config } from './app-config';

import '@styles/reset.css';
import '@styles/variables.css';

if (config.SENTRY_URL) {
  startSentry(config.SENTRY_URL);
  setSentryContext('build', {
    buildDate: process.env.__BUILD_DATE__,
    buildRef: process.env.__BUILD_REF__,
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

const root = (
  <QueryClientProvider client={queryClient}>
    <BrowserRouter basename={process.env.VITE_BASE_PATH || ''}>
      <Routes>
        <Route
          path="/jf/:journeyUuid/:formUuid"
          element={<JourneyForm />}
          errorElement={<RouteErrorBoundary />}
        />
        <Route path="/:uuid" element={<ComboSendForm />} errorElement={<RouteErrorBoundary />} />
      </Routes>
      <Toaster />
    </BrowserRouter>
  </QueryClientProvider>
);

render(root, document.getElementById('root'));
